import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { onEnterOrSpacePress } from '@hivebrite/utils';
import { Box } from '@design-system/box';
import { CATEGORIES, FontAwesomeIcon } from '@design-system/font-awesome-icon';
import { __, s__ } from '@design-system/i18n';
import { Loader } from '@design-system/loader';
import { useTheme } from '@design-system/theme';
export const UploadContainer = ({ ariaLabel = s__('Accessibility|Upload your image'), handleEdit, iconName, iconSize, isLoading, isOver, label, }) => {
    const theme = useTheme();
    return (_jsxs(WrapperUploadImage, { "$isOver": isOver, "aria-label": ariaLabel, onClick: handleEdit, onKeyPress: onEnterOrSpacePress(handleEdit), role: "button", tabIndex: 0, children: [_jsx(Box, { color: "primary", mt: label ? 4 : undefined, children: isLoading ? (_jsx(Loader, { size: 48, strokeWidth: 4 })) : (_jsx(FontAwesomeIcon, { color: isOver ? 'white' : 'primary', height: iconSize, iconName: iconName, iconType: CATEGORIES.DUOTONE })) }), label && (_jsx(Box, { color: isOver ? 'white' : theme.input.color, fontSize: 1, my: 4, px: 3, textAlign: "center", children: isOver ? __('Drop your image here') : label }))] }));
};
const WrapperUploadImage = styled(Box).attrs(({ $isOver, theme }) => ({
    alignItems: 'center',
    bg: $isOver ? 'primary' : theme.input.bg,
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'center',
    width: '100%',
})) `
  border: ${({ $isOver }) => ($isOver ? 0 : 1)}px dashed
    ${(props) => props.theme.colors.primary};
  border-radius: ${({ theme }) => `${theme.themeVariables.globalBorderRadius}px`};
  cursor: ${(props) => props.onClick && 'pointer'};
  overflow: hidden;
  position: relative;
  user-select: none;
`;
//# sourceMappingURL=UploadContainer.js.map